// Import jQuery and make it globally available
import $ from 'jquery';
window.$ = window.jQuery = $;

// Import Bootstrap components
import 'bootstrap';

// Import jQuery plugins
import 'jquery-backstretch';

// Import your stylesheets
// import './assets/stylesheets/style.scss';

// Import your app entry point
import './App';

console.log('Main.js initialized successfully');